// Refetched by name: importing Standard's generated document loads its module in every test that renders the app bar.
export const HOME_VIEW_CASELOAD = 'fetchParticipantsForHomeView'
